/**
 * A global namespace for keyboard event keys.
 */
const keyboardEventKeys = {
  Backspace: 'Backspace', //  8
  Tab: 'Tab', //  9
  Enter: 'Enter', // 13
  Shift: 'Shift', // 16
  Control: 'Control', // 17
  Alt: 'Alt', // 18
  Pause: 'Pause', // 19
  CapsLock: 'CapsLock', // 20
  Escape: 'Escape', // 27
  Scape: 'Space', // 32
  ArrowLeft: 'ArrowLeft', // 37
  ArrowUp: 'ArrowUp', // 38
  ArrowRight: 'ArrowRight', // 39
  ArrowDown: 'ArrowDown', // 40
  Insert: 'Insert', // 45
  Delete: 'Delete', // 46
  Meta: 'Meta', // 91 windows key
  ContextMenu: 'ContextMenu', // 93
  ScrollLock: 'ScrollLock', // 145
};

export default keyboardEventKeys;
